"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../../..");
var SelectTypPomucky_1 = __importDefault(require("../../../Form/fields/SelectTypPomucky"));
var PomuckyTable_1 = __importDefault(require("./PomuckyTable"));
var utils_1 = require("./utils");
var ButtonWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  text-align: center;\n  margin-top: 1rem;\n  & > * + * {\n    margin-left: 1rem;\n  }\n"], ["\n  align-items: center;\n  text-align: center;\n  margin-top: 1rem;\n  & > * + * {\n    margin-left: 1rem;\n  }\n"])));
var RemoveBody = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 20px;\n  text-align: center;\n  font-weight: bold;\n"], ["\n  padding: 20px;\n  text-align: center;\n  font-weight: bold;\n"])));
var EditHeader = styled_components_1.default.h2(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: 400;\n  font-size: 28px;\n  line-height: 140%;\n  margin-bottom: 30px;\n  color: #000000;\n"], ["\n  font-weight: 400;\n  font-size: 28px;\n  line-height: 140%;\n  margin-bottom: 30px;\n  color: #000000;\n"])));
var PridatPomucku = styled_components_1.default(__1.LinkButton)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 22px;\n  text-decoration-line: underline;\n  color: #2362a2;\n"], ["\n  font-size: 16px;\n  line-height: 22px;\n  text-decoration-line: underline;\n  color: #2362a2;\n"])));
var validation = function (values) {
    var identifikacelens = ramda_1.lensPath(['idPomucky']);
    var typLens = ramda_1.lensPath(['typPomucky']);
    var pipe1 = ramda_1.pipe(ramda_1.when(function () { return !ramda_1.view(identifikacelens, values); }, ramda_1.set(identifikacelens, 'Identifikace pomůcky je povinná')), ramda_1.when(function () { return !ramda_1.view(typLens, values); }, ramda_1.set(typLens, 'Typ pomůcky je povinný')))({});
    return Object.keys(pipe1).length > 0 ? __assign(__assign({}, pipe1), { dot: '' }) : pipe1;
};
var PomuckyField = function (_a) {
    var jmeno = _a.jmeno, label = _a.label, jeZnalec = _a.jeZnalec, druhOsoby = _a.druhOsoby, _b = _a.readOnly, readOnly = _b === void 0 ? false : _b;
    var _c = __1.useCiselnik('typyPomucek'), data = _c.data, loading = _c.loading, error = _c.error;
    var _d = formik_1.useField(jmeno), field = _d[0], helpers = _d[2];
    var values = field.value || [];
    var odebratPomucku = __1.useBoolean(false);
    var _e = react_1.useState(), odebrat = _e[0], setOdebrat = _e[1];
    var editPomucku = __1.useBoolean(false);
    var _f = react_1.useState(), edit = _f[0], setEdit = _f[1];
    if (error) {
        return react_1.default.createElement(react_1.default.Fragment, null, error);
    }
    if (loading) {
        return react_1.default.createElement(react_1.default.Fragment, null, "na\u010D\u00EDt\u00E1n\u00ED");
    }
    var handleRemove = function () {
        helpers.setValue(values.filter(function (p) { return p !== odebrat; }));
        odebratPomucku.setFalse();
    };
    var onRemove = function (item) {
        setOdebrat(item);
        odebratPomucku.toggle();
    };
    var editPomucka = function (item) {
        var index = item ? values.indexOf(item) : undefined;
        setEdit({ id: index, value: item });
        editPomucku.setTrue();
    };
    var handleSave = function (val) {
        var _a;
        var value = __assign(__assign({}, val), { typPomucky: {
                id: val.typPomucky.id,
                nazev: (_a = data === null || data === void 0 ? void 0 : data.find(function (p) { return p.id === val.typPomucky.id; })) === null || _a === void 0 ? void 0 : _a.nazev,
            } });
        if (edit.id === undefined) {
            helpers.setValue(ramda_1.append(value, values));
        }
        else
            helpers.setValue(ramda_1.set(ramda_1.lensIndex(edit.id), value, values));
        editPomucku.setFalse();
        setEdit(undefined);
    };
    var closeEditPomucka = function () {
        editPomucku.setFalse();
        setEdit(undefined);
    };
    var getDruhPomucky = function () {
        if (jeZnalec)
            return __1.DruhPomucky.PrukazZnalce;
        if (druhOsoby === __1.TlumocniciDruhOsoby.prekladatel)
            return __1.DruhPomucky.PrukazPrekladatele;
        return __1.DruhPomucky.PrukazTlumocnika;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(utils_1.StyledH2, { isDetail: false }, label),
        react_1.default.createElement(PomuckyTable_1.default, { data: values, isDetail: false, onEdit: readOnly ? undefined : function (item) { return editPomucka(item); }, onRemove: readOnly ? undefined : function (item) { return onRemove(item); } }),
        !readOnly && (react_1.default.createElement(PridatPomucku, { type: "button", onClick: function () { return editPomucka(undefined); } }, "+ P\u0159idat pom\u016Fcku")),
        react_1.default.createElement(__1.Popup, { open: editPomucku.value, onClose: function () { return closeEditPomucka(); } },
            react_1.default.createElement(__1.Form, { initialValues: (edit === null || edit === void 0 ? void 0 : edit.value) || {}, onSubmit: function (val) { return handleSave(val); }, validate: validation }, function () { return (react_1.default.createElement(__1.Padder, null,
                react_1.default.createElement(EditHeader, null,
                    (edit === null || edit === void 0 ? void 0 : edit.value) ? 'Úprava' : 'Zápis',
                    " pom\u016Fcky"),
                react_1.default.createElement(__1.TextField, { label: "Identifikace pom\u016Fcky", name: "idPomucky" }),
                react_1.default.createElement(SelectTypPomucky_1.default, { label: "Typ pom\u016Fcky", name: "typPomucky.id", filterResult: function (d) { return d.id === getDruhPomucky(); } }),
                react_1.default.createElement(__1.DateRangeField, { fromLabel: "Datum vyd\u00E1n\u00ED", toLabel: "Datum vr\u00E1cen\u00ED", fromName: "datumVydani", toName: "datumVraceni", size: "lg" }),
                react_1.default.createElement(__1.TextAreaField, { name: "poznamka", label: "Pozn\u00E1mka", toolTip: "Dopl\u0148te pozn\u00E1mku k vydan\u00E9 pom\u016Fcce" }),
                react_1.default.createElement(ButtonWrapper, null,
                    react_1.default.createElement(__1.Button, { name: "ZrusitPomucku", onClick: function () { return closeEditPomucka(); } }, "Zru\u0161it"),
                    react_1.default.createElement(__1.Button, { name: "UlozitPomucku", type: "submit", primary: true }, "Ulo\u017Eit")))); })),
        react_1.default.createElement(__1.Popup, { open: odebratPomucku.value, onClose: function () { return odebratPomucku.setFalse(); } },
            react_1.default.createElement(RemoveBody, null,
                "Opravdu chcete z\u00E1znam o t\u00E9to pom\u016Fcce smazat?",
                react_1.default.createElement(ButtonWrapper, null,
                    react_1.default.createElement(__1.Button, { name: "Zrusit", onClick: function () { return odebratPomucku.setFalse(); }, primary: false }, "Ne, zachovat"),
                    react_1.default.createElement(__1.Button, { name: "Odebrat", onClick: function () { return handleRemove(); }, warning: true }, "Ano, smazat"))))));
};
PomuckyField.defaultProps = {
    druhOsoby: undefined,
    readOnly: false,
};
exports.default = PomuckyField;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
